import { METERS_PER_SEC_TO_MPH_FACTOR } from 'features/weatherStations/weatherStations.constants';
import { WeatherStationObservation } from 'features/weatherStations/weatherStations.types';

export const getLatestObservation = (
  observations: WeatherStationObservation[],
): WeatherStationObservation | null => {
  if (observations.length === 0) return null;

  // Sort observations by timestamp (newest first)
  const sortedObs = [...observations].sort(
    (a, b) => b.timestamp.getTime() - a.timestamp.getTime(),
  );

  return sortedObs[0];
};

/**
 * Formats a number to one decimal place, removing trailing zeros.
 * Examples: 1.0 -> "1", 2.6 -> "2.6", 55.9994 -> "56"
 */
export const parseNumericValue = (number: number): string => {
  const roundedNumber = Math.round(number * 10) / 10;
  return roundedNumber % 1 === 0
    ? roundedNumber.toString()
    : roundedNumber.toFixed(1);
};

export const convertMetersPerSecToMph = (metersPerSec: number): string => {
  const mph = metersPerSec * METERS_PER_SEC_TO_MPH_FACTOR;
  return parseNumericValue(mph);
};

export const convertCelsiusToFahrenheit = (celsius: number): string => {
  const fahrenheit = celsius * (9 / 5) + 32;
  return parseNumericValue(fahrenheit);
};
